import { TableCell } from '@mui/material'
import React from 'react'
import MyTable from '../../UI/table/MyTable'
import MyTableNotFound from '../../UI/table/MyTableNotFound'
import BoxOneSeriesItem from './BoxOneSeriesItem'

const BoxOneTable = ({ boxId, serieses, count, offset, setOffset, limit, setLimit }) => {
  return (
    <MyTable
        head={
            <>
                <TableCell align="center">ID</TableCell>
                <TableCell align="center">Серія</TableCell>
                <TableCell align="center">Тип</TableCell>
                <TableCell align="center">Товар</TableCell>
                <TableCell align="center">Упаковано?</TableCell>
                <TableCell align="right">Дії</TableCell>
            </>
        }
        body={
            serieses && serieses.length > 0 ?
                serieses.map(series => 
                    <BoxOneSeriesItem
                        key={series.id}
                        // packId={packId}
                        series={series} 
                    />
                )
            : 
                <MyTableNotFound
                    text='Товарів не знайдено' 
                    columns={6}
                />
        }
        name='товарів'
        count={count}
        limit={limit}
        setLimit={setLimit}
        offset={offset}
        setOffset={setOffset}
    />
  )
}

export default BoxOneTable